import { render } from "./QRCodePage.vue?vue&type=template&id=68aaa59b&scoped=true"
import script from "./QRCodePage.vue?vue&type=script&lang=js"
export * from "./QRCodePage.vue?vue&type=script&lang=js"

import "./QRCodePage.vue?vue&type=style&index=0&id=68aaa59b&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68aaa59b"]])

export default __exports__